import { busyWhile } from "lib/@components/busy/busy-while"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { restoreSkillMap } from "routes/skill-mapper/controller/restore-skill-map"

/**
 * Restore an archived skill map, from the header menu or the archived banner.
 *
 * @param {{ id: string, name: string }} map
 */
export async function restoreSkillMapWithFeedback(map) {
    await busyWhile(() => restoreSkillMap({ id: map.id }), "Restoring skill mapping...")
    successSnackbar(`Skill map "${map.name}" restored`)
}
